

const Baldwin = ({
    SurgeryFormData,
    setSurgeryFormData,
    currentPage,
    pageRefs,
    pageTitles,
    isNext,
    invalidFields,
    handleInputChange,
    handleCheckboxChange,
    verifyDob,
    setVerifyDob,
    signatures,
    setSignatures,
    isEditing,
    toggleEditMode,
    updateSignatureData,
    clearSignature,
    canvasRefs,
    surgeonOptionsMap,
    docSignature,
    logo,
    renderNextButton,
    renderSurgeryUploadButton,
    surgeryUpload,
    formatDate,
    handleMedicationTimeChange,
    getCentralAmericaDate,
    getCentralAmericaTime,
    handleNext,
    Paragraph,
    Logo,
    Head,
    SignatureField,
    TextInput,
    MedTimePicker,
    TextArea,
    DatePickerInput,
    RadioGroup,
    RSIConsent,
    formattedDate,
    LeftCheckBox,
    handleProcedureChange
}) => {
    return (
        <>
            <form className="bg-white">

                {/* PAGE 0 */}
                {currentPage === 0 && (
                    <RSIConsent
                        pageRefs={pageRefs}
                        currentPage={currentPage}
                        logo={logo}
                        pageTitles={pageTitles}
                        SurgeryFormData={SurgeryFormData}
                        surgeonOptionsMap={surgeonOptionsMap}
                        docSignature={docSignature}
                        setSignatures={setSignatures}
                        setSurgeryFormData={setSurgeryFormData}
                        handleInputChange={handleInputChange}
                        invalidFields={invalidFields}
                        isNext={isNext}
                        isEditing={isEditing}
                        signatures={signatures}
                        canvasRefs={canvasRefs}
                        updateSignatureData={updateSignatureData}
                        clearSignature={clearSignature}
                        toggleEditMode={toggleEditMode}
                        getCentralAmericaDate={getCentralAmericaDate}
                        getCentralAmericaTime={getCentralAmericaTime}
                        Logo={Logo}
                        Head={Head}
                        Paragraph={Paragraph}
                        RadioGroup={RadioGroup}
                        TextInput={TextInput}
                        SignatureField={SignatureField} />
                )}

                {/* PAGE 1 */}
                {currentPage === 1 && (
                    <div ref={pageRefs.current[currentPage]} className="max-w-4xl w-full bg-white px-2 mx-5 py-2">
                        {/* page 1 JSX */}
                        <div className="max-w-5xl w-full bg-white p-6 flex items-center  justify-center gap-4">
                            {/* Left word */}
                            <span className="text-lg font-medium">
                                <span className="text-black-500 text-center">Retina Pre Op Orders</span>
                                <br />
                                <span className="text-black-500 text-center">Sean Allison, MD</span>
                            </span>

                        </div>

                        <div className="max-w-5xl w-full bg-white p-6 flex justify-end">
                            <span className="text-lg font-medium">
                                Patient Label - {SurgeryFormData.first_name} {SurgeryFormData.last_name}  {SurgeryFormData.dob}
                            </span>
                        </div>


                        <div className="max-w-5xl w-full bg-white p-6 flex justify-start">
                            <TextInput
                                id="date_time"
                                label="Date/Time"
                                value={SurgeryFormData.date_time}
                                onChange={handleInputChange}
                                disabled={surgeryUpload}
                                invalid={invalidFields.includes("date_time") && !SurgeryFormData.date_time}
                            />
                        </div>

                        <div className="max-w-5xl w-full bg-white p-6 flex justify-start">
                            <TextInput
                                id="procedure_description"
                                label="Proposed Procedure"
                                required
                                value={SurgeryFormData.procedure_description}
                                onChange={handleInputChange}
                                disabled={surgeryUpload}
                                invalid={invalidFields.includes("procedure_description") && !SurgeryFormData.procedure_description}
                            />
                        </div>

                        <div className="max-w-5xl w-full bg-white p-6 flex justify-between">
                            <LeftCheckBox
                                label="RIGHT EYE"
                                items={Object.keys(SurgeryFormData.consent_procedures.right_eye)}
                                values={SurgeryFormData.consent_procedures.right_eye}
                                onChange={(proc, val) =>
                                    handleProcedureChange("right_eye", proc, val)
                                }
                            />

                            <LeftCheckBox
                                label="LEFT EYE"
                                items={Object.keys(SurgeryFormData.consent_procedures.left_eye)}
                                values={SurgeryFormData.consent_procedures.left_eye}
                                onChange={(proc, val) =>
                                    handleProcedureChange("left_eye", proc, val)
                                }
                            />
                        </div>


                        <div className="p-4 w-full">

                            <p className="text-base text-black leading-relaxed my-4">
                                Diet:
                            </p>

                            <div className="flex flex-wrap gap-2">
                                <label htmlFor='npo' className="flex items-center space-x-2 select-none my-4">
                                    <input
                                        type="checkbox"
                                        id='npo'
                                        disabled={surgeryUpload}
                                        checked={SurgeryFormData.npo || false}
                                        onChange={(e) =>
                                            setSurgeryFormData((prev) => ({
                                                ...prev,
                                                npo: !SurgeryFormData.npo,
                                            }))
                                        }
                                        className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                    />
                                    <span className="text-base font-medium text-black">
                                        NPO
                                    </span>

                                </label>

                            </div>


                        </div>

                        <div className=" p-4 w-full">
                            <p className="text-base text-black leading-relaxed mb-4">
                                Dilation Eyes
                            </p>
                            <div className="flex flex-wrap gap-4">
                                {Object.keys(SurgeryFormData.dilation_eyes).map((eye) => (
                                    <div key={eye} className="flex items-center space-x-3">
                                        <input
                                            type="checkbox"
                                            disabled={surgeryUpload}
                                            name={eye}
                                            checked={SurgeryFormData.dilation_eyes[eye] === true}
                                            onChange={() =>
                                                handleCheckboxChange(
                                                    "dilation_eyes",
                                                    eye,
                                                    !SurgeryFormData.dilation_eyes[eye]
                                                )
                                            }
                                            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
                                        />
                                        <span className="text-black">{eye}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="flex flex-wrap gap-4">
                                {Object.keys(SurgeryFormData.dilation_medications).map((med) => (
                                    <div key={med} className="flex items-center space-x-3">
                                        <input
                                            type="checkbox"
                                            disabled={surgeryUpload}
                                            name={med}
                                            checked={SurgeryFormData.dilation_medications[med] === true}
                                            onChange={() =>
                                                handleCheckboxChange(
                                                    "dilation_medications",
                                                    med,
                                                    !SurgeryFormData.dilation_medications[med]
                                                )
                                            }
                                            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
                                        />
                                        <span className="text-black">{med}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className=" p-4 w-full">
                            <p className="text-base text-black leading-relaxed mb-4">
                                Medications Available in Operating Room
                            </p>

                            <div className="flex flex-wrap gap-4">
                                {Object.keys(SurgeryFormData.meds_in_op_room).map((med) => (
                                    <div key={med} className="flex items-center space-x-3">
                                        <input
                                            type="checkbox"
                                            disabled={surgeryUpload}
                                            name={med}
                                            checked={SurgeryFormData.meds_in_op_room[med] === true}
                                            onChange={() =>
                                                handleCheckboxChange(
                                                    "meds_in_op_room",
                                                    med,
                                                    !SurgeryFormData.meds_in_op_room[med]
                                                )
                                            }
                                            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
                                        />
                                        <span className="text-black">{med}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className=" p-4 w-full">
                            <p className="text-base text-black leading-relaxed mb-4">
                                Lab/Diagnostics
                            </p>

                            <div className="flex flex-wrap gap-4">
                                {Object.keys(SurgeryFormData.labs_diagnostic).map((lab) => (
                                    <div key={lab} className="flex items-center space-x-3">
                                        <input
                                            type="checkbox"
                                            disabled={surgeryUpload}
                                            name={lab}
                                            checked={SurgeryFormData.labs_diagnostic[lab] === true}
                                            onChange={() =>
                                                handleCheckboxChange(
                                                    "labs_diagnostic",
                                                    lab,
                                                    !SurgeryFormData.labs_diagnostic[lab]
                                                )
                                            }
                                            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
                                        />
                                        <span className="text-black">{lab}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                           <div className=" p-4 w-full">
                            <p className="text-base text-black leading-relaxed mb-4">
                                Lab/Diagnostics
                            </p>

                            <div className="flex flex-wrap gap-4">
                                {Object.keys(SurgeryFormData.iv_fluids).map((iv) => (
                                    <div key={iv} className="flex items-center space-x-3">
                                        <input
                                            type="checkbox"
                                            disabled={surgeryUpload}
                                            name={iv}
                                            checked={SurgeryFormData.iv_fluids[iv] === true}
                                            onChange={() =>
                                                handleCheckboxChange(
                                                    "iv_fluids",
                                                    iv,
                                                    !SurgeryFormData.iv_fluids[iv]
                                                )
                                            }
                                            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
                                        />
                                        <span className="text-black">{iv}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="flex col-span-6">
                            <div className="w-[75%] mb-2">

                                {SurgeryFormData['doctor_signature'] && !isEditing['doctor_signature'] ? ( // Toggle between edit and display mode

                                    <img
                                        src={SurgeryFormData['doctor_signature']}
                                        alt="Signature"
                                        loading="eager"
                                        style={{
                                            width: '300px',
                                            height: '100px',
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                            border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                            objectFit: 'contain',
                                            display: 'block',
                                        }}
                                    />

                                ) : (
                                    null
                                )}

                            </div>
                        </div>

                    </div>

                )}

            </form>

            {/* Footer Buttons */}
            <div className="flex justify-end mx-5">
                    {[0].includes(currentPage)
                        ? renderNextButton()
                        : renderSurgeryUploadButton()}
            </div>
        </>
    );
};

export default Baldwin;
